import { router } from "expo-router";
import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

export default function AdminDashboard() {
  return (
    <SafeAreaView edges={["top"]} style={styles.safe}>
      <View style={styles.container}>
        <Text style={styles.title}>Admin Dashboard</Text>

        <Pressable
          style={styles.card}
          onPress={() => router.push("/admin/taxonomy")}
        >
          <Text style={styles.cardTitle}>Taxonomy</Text>
          <Text style={styles.cardDesc}>Manage categories and subcategories</Text>
        </Pressable>

        <Pressable
          style={styles.card}
          onPress={() => router.push("/admin/locations")}
        >
          <Text style={styles.cardTitle}>Locations</Text>
          <Text style={styles.cardDesc}>Manage counties, cities, and areas</Text>
        </Pressable>

        <Pressable
          style={styles.card}
          onPress={() => router.push("/admin/businesses")}
        >
          <Text style={styles.cardTitle}>Businesses</Text>
          <Text style={styles.cardDesc}>Manage businesses and listings</Text>
        </Pressable>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safe: {
    flex: 1,
    backgroundColor: "#fff",
  },

  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 14,
    backgroundColor: "#fff",
  },

  title: {
    fontSize: 24,
    fontWeight: "900",
    marginBottom: 22,
    color: "#111827",
  },

  card: {
    borderWidth: 1,
    borderColor: "#eee",
    borderRadius: 16,
    padding: 16,
    marginBottom: 14,
    backgroundColor: "#fff",
  },

  cardTitle: {
    fontSize: 17,
    fontWeight: "900",
    color: "#111827",
  },

  cardDesc: {
    marginTop: 6,
    opacity: 0.7,
    color: "#374151",
    fontSize: 14,
    lineHeight: 20,
  },
});
